import { MODAL_LAYER as e } from "../layers.js";
import { cva as t } from "class-variance-authority";
// src/design/modal/style.ts
var n = t([
	"fixed inset-0 bg-scrim",
	e,
	"data-[state=open]:animate-[backdrop-fade-in_0.2s_ease-out_forwards]",
	"data-[state=closed]:animate-[backdrop-fade-out_0.15s_ease-in_forwards]"
]), r = t(["fixed inset-0 flex justify-center", e], {
	variants: {
		centered: {
			true: "items-center p-0",
			false: "items-start pt-20 p-4"
		},
		scrollMode: {
			outside: "overflow-y-auto items-start pt-[35px] pb-[35px]",
			inside: "overflow-hidden"
		}
	},
	compoundVariants: [{
		scrollMode: "outside",
		centered: !0,
		className: "items-start pt-[35px] pb-[35px]"
	}],
	defaultVariants: {
		centered: !1,
		scrollMode: "inside"
	}
}), i = t([
	"relative rounded-lg bg-card border border-border shadow-overlay",
	"data-[state=open]:animate-[fade-in_0.2s_ease-out_forwards]",
	"data-[state=closed]:animate-[fade-out_0.15s_ease-in_forwards]",
	"flex flex-col"
], {
	variants: {
		size: {
			sm: "w-[90vw] max-w-sm p-4",
			md: "w-[90vw] max-w-md p-5",
			lg: "w-[90vw] max-w-lg p-5",
			xl: "w-[90vw] max-w-xl p-5",
			"2xl": "w-[90vw] max-w-2xl p-6",
			"3xl": "w-[90vw] max-w-3xl p-6",
			"4xl": "w-[90vw] max-w-4xl p-6",
			"5xl": "w-[90vw] max-w-5xl p-6",
			"6xl": "w-[90vw] max-w-6xl p-6",
			full: "w-screen h-screen max-w-none max-h-none rounded-none p-6"
		},
		scrollMode: {
			outside: "my-8",
			inside: "max-h-[calc(100vh-8rem)]"
		}
	},
	defaultVariants: {
		size: "md",
		scrollMode: "inside"
	}
}), a = t(["font-semibold text-foreground"], {
	variants: { size: {
		sm: "text-base mb-2",
		md: "text-md mb-2",
		lg: "text-lg mb-3"
	} },
	defaultVariants: { size: "md" }
}), o = t(["text-muted-foreground"], {
	variants: { size: {
		sm: "text-xs mb-3",
		md: "text-sm mb-4",
		lg: "text-base mb-4"
	} },
	defaultVariants: { size: "md" }
}), s = t(["cursor-pointer"], {
	variants: { position: {
		absolute: "absolute top-4 right-3 text-muted-foreground hover:text-foreground transition-colors p-1 rounded-md hover:bg-muted",
		relative: ""
	} },
	defaultVariants: { position: "absolute" }
}), c = t(["flex items-center gap-2 pt-4 mt-4"], {
	variants: { align: {
		left: "justify-start",
		center: "justify-center",
		right: "justify-end",
		between: "justify-between"
	} },
	defaultVariants: { align: "right" }
});
export { n as backdropVariants, s as closeTriggerVariants, i as contentVariants, o as descriptionVariants, c as footerVariants, r as positionerVariants, a as titleVariants };

//# sourceMappingURL=style.js.map